import React, { useMemo } from "react";
import Select, { components } from "react-select";
import BankTransfersCategoryBadge from "./BankTransfersCategoryBadge";

const BankTransfersCategoryFilter = ({
    value,
    categories,
    onChange
}) => {
    const groupedOptions = useMemo(() => {
        const groups = categories.reduce(
            (result, category) => {
                if (!result[category.groupName]) {
                    result[category.groupName] = [];
                }

                result[category.groupName].push({
                    value: category.id,
                    label: category.name,
                    category
                });

                return result;
            },
            {}
        );

        return Object.entries(groups).map(
            ([groupName, options]) => ({
                label: groupName,
                options
            })
        );
    }, [categories]);

    const selectedOption = useMemo(() => {
        const category = categories.find(
            (c) => c.id === value
        );

        if (!category) {
            return null;
        }

        return {
            value: category.id,
            label: category.name,
            category
        };
    }, [categories, value]);

    const SingleValue = (props) => (
        <components.SingleValue {...props}>
            <BankTransfersCategoryBadge
                category={props.data.category}
            />
        </components.SingleValue>
    );

    const Option = (props) => (
        <components.Option {...props}>
            <BankTransfersCategoryBadge
                category={props.data.category}
            />
        </components.Option>
    );

    return (
        <div className="bank-transfer-category-filter">
            <Select
                options={groupedOptions}
                value={selectedOption}
                onChange={(option) =>
                    onChange(option?.value ?? null)
                }
                isClearable
                isSearchable
                placeholder="Wszystkie kategorie"
                components={{
                    SingleValue,
                    Option
                }}
                classNamePrefix="bank-filter-category"
                noOptionsMessage={() =>
                    "Brak kategorii"
                }
            />
        </div>
    );
};

export default BankTransfersCategoryFilter;